import React from 'react'
// import profileImg from "../assets/soumyajit profile.jpg";
import profileDP from "../assets/soumyajit_dp.jpg"
// eslint-disable-next-line
import { leetCodeCount, projectsCount, yearsOfExperienceCount, linkedinId, twitterId, telegramId } from '../assets/data';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import AnimateNumbers from './AnimateNumbers';
import Anchor from './CustomElements';
library.add(fab);
// css design in about.css 


const BioSection = () => {
    
    return (
        <div className='section1 animation'>
            <div className='bio_and_profile'>
                <div className='bio_container'>
                    <h2 className='bio_title hoverElement'>Biography</h2>
                    <p>
                        Hi, I’m a full stack developer and competitive programmer over {yearsOfExperienceCount} years of experience. I’m passionate about creating beautiful, functional, and user-centered digital experiences.
                    </p>
                    <p>
                        I believe design is about solving problems and creating intuitive experiences for users. I bring my commitment to design excellence and user-centered thinking to every project I work on.
                    </p>
                    <div className='social_icons_container'>
                        <Link to={linkedinId} target='_blank' className='social_icons' data-cursor={true}>
                            <FontAwesomeIcon icon={["fab", "linkedin"]} className='icon linkedin' />
                        </Link>
                        <Link to={twitterId} target='_blank' className='social_icons' data-cursor={true}>
                            <FontAwesomeIcon icon={["fab", "x-twitter"]} className='icon twitter' />
                        </Link>
                        <Link to={telegramId} target='_blank' className='social_icons' data-cursor={true}>
                            <FontAwesomeIcon icon={["fab", "telegram"]} className='icon telegram' />
                        </Link>
                    </div>
                </div>
                <div className='profileImg_container'>
                    <img src={profileDP} alt='profile_img' className='profile_image' style={{ borderRadius: "10px" }} />
                </div>
                <div className='counts_container'>
                    <div className='count_data'>
                        <h1 className='count hoverElement'><AnimateNumbers targetNumber={leetCodeCount} />+</h1>
                        <p><Anchor href={"https://leetcode.com/soumyajit29/"}>LeetCode</Anchor> Problem Solved</p>
                    </div>
                    {/* <div className='count_data'>
                        <h1 className='count hoverElement'><AnimateNumbers targetNumber={codeshefRankCount} /></h1>
                        <p>Rank In <Link to={"https://www.codechef.com/users/soumyajitmahi7"} target='_blank' className='codingProfiles'>CodeShef</Link></p>
                    </div> */}
                    <div className='count_data'>
                        <h1 className='count hoverElement'><AnimateNumbers targetNumber={projectsCount} />+</h1>
                        <p>Projects Completed</p>
                    </div>
                    <div className='count_data'>
                        <h1 className='count hoverElement'><AnimateNumbers targetNumber={yearsOfExperienceCount} />+</h1>
                        <p>Years Of Experience</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BioSection